/**
 * The compiled-navigation registration seam (#1584).
 *
 * The compiled bind (`render-dom-nav.ts`) is real code that only templates
 * carrying an AOT navigation payload can ever reach, so the eager kernel
 * carries none of it: this module is the one thing the kernel keeps — a
 * synchronous binder slot plus its registration function, a few bytes. The
 * nav module registers `bindCompiledClone` into the slot at import time (a
 * module side-effect, so a clone bind stays synchronous), and the AOT
 * emitter's preamble imports the nav module exactly when a site carries a
 * payload — compiled apps pay for it, plain-template apps never do.
 *
 * Fail-closed: with no binder registered, a payload present on the template
 * still cannot bind — the mount falls back to the recorded-plan path and the
 * payload reads as `rejected` through `compiledNavState`, exactly as a
 * payload the validation gate rejected.
 */
let binder = null;
/**
 * Installs the compiled bind. Called once, from the nav module's import-time
 * side-effect; the last registration wins, which keeps the seam a plain slot
 * rather than a registry with lifecycle rules.
 */
export function registerCompiledNavBinder(registered) {
    binder = registered;
}
/** The registered compiled bind, or null while the nav module is unloaded. */
export function compiledNavBinder() {
    return binder;
}
//# sourceMappingURL=render-dom-nav-hook.js.map